export default __webpack_public_path__ + "static/media/img-17.fe5a0c24.jpg";